let { View, Utils } = window.App;
import SplitText from './split-text';


View.addHook( 'init', v => {
    v.$( '.btn' ).each( function(){
        new SplitText( this );
    } );
}, 0 )



// WEBPACK FOOTER //
// ./resources/js/modules/button.js